module.exports = __webpack_public_path__ + "img/map_body_hotspots2.fc905151.png";